import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { translate } from 'react-i18next';
import { connectModal } from '../../features/modal/hoc';

const MODAL_ID = 'INFO_MODAL';

const InfoModal = ({ t, children, modalActions, isVisible, title, text }) => {
  return (
    <span>
      {cloneElement(children, { onClick: modalActions.show })}
      <Modal
        title={title}
        visible={isVisible}
        onCancel={modalActions.hide}
        width={700}
        footer={
          <Button size="small" type="primary" onClick={modalActions.hide}>
            {t('Zavrieť')}
          </Button>
        }
      >
        <div>{text}</div>
      </Modal>
    </span>
  );
};

InfoModal.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  modalActions: PropTypes.object.isRequired,
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
};

export default translate()(connectModal(MODAL_ID)(InfoModal));



// WEBPACK FOOTER //
// ./src/common/modals/InfoModal.js